import React from 'react';
import styles from './IntroBlock.module.scss';
import phoneDemo from '../../../assets/images/龍寶寶_babyDragon_iphoneDemo.webp'
import logo from '../../../assets/images/龍寶寶_babyDragonHead.jpg'

const introBlock = () => (
  <div className={styles.wrapper}>
    <div className={[styles.container].join(' ')}>
      <div className={[styles.imgBlock, 'col-xl-6', 'col-12','px-0'].join(' ')}>
        <img src={phoneDemo} alt="龍寶寶手機範例" />
      </div>
      <div className={[styles.textBlock, 'col-xl-6', 'col-12'].join(' ')}>
        <div className={[styles.babyDragonBlock].join(' ')}>
          <div className={[styles.babyDragonImageBlock].join(' ')}>
            <img src={logo} alt="龍寶寶logo" />
          </div>
          <div className={[styles.babyDragonTextBlock].join(' ')}>
            <h1>分帳龍寶寶</h1>
            <h3>不分帳就在睡，一款為多人分帳而生的LineBot小工具</h3>
          </div>
        </div>
        <p>特別適合用於多人短期出遊、室友日常開銷的LINE小工具，無需額外下載，只要將龍寶寶加入Line群組即可開始使用</p>
        <div className={[styles.bottonGroup].join(' ')}>
          <a href='https://lin.ee/52gLqtX' target="_blank">加入好友立即試用</a>
          <a href='https://timeline.line.me/post/_dVuj6zE0G3E-kSf6FaUQZ4y9u478TP_HsDOCitI/1161286607303029747' target="_blank">V 3.1 更新公告</a>
        </div>
      </div>
    </div>
  </div>
)

export default introBlock
